import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import ReactPaginate from "react-paginate";

export default function Pagination({ items, itemsPerPage, handlePageClick }) {
  const pageCount = Math.ceil(items?.length / itemsPerPage);

  return (
    <Pagination.Wrapper>
      <ReactPaginate
        previousClassName="pagination-prev-btn"
        nextClassName="pagination-next-btn"
        disabledClassName="paginationDisabled"
        breakClassName="pagination-break"
        breakLabel="..."
        containerClassName="pagination"
        activeClassName="pagination-active"
        nextLabel={<Text fontWeight="800"><BsChevronRight /></Text>}
        onPageChange={handlePageClick}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        previousLabel={<Text fontWeight="800"><BsChevronLeft /></Text>}
        renderOnZeroPageCount={null}
      />
    </Pagination.Wrapper>
  );
}

Pagination.Wrapper = styled.div`
  .pagination {
    display: flex;
    align-items: center;
    list-style: none;
    outline: none;
    font-size: 14px;
  }
  .pagination > .pagination-active > a {
    background-color: #fff;
    border-color: #0765FF;
    color: #fff;
  }
  .pagination > li > a {
    padding: 4px 10px;
    outline: none;
    margin: 0 4px;
    border-radius: 4px;
    cursor: pointer;
  }
  .pagination > .pagination-active > a,
  .pagination > .pagination-active > span,
  .pagination > .pagination-active > a:hover,
  .pagination > .pagination-active > span:hover,
  .pagination > .pagination-active > a:focus,
  .pagination > .pagination-active > span:focus {
    background-color: #fff;
    border: 1px solid #0765FF;
    color: #0765FF;
    outline: none;
  }
  .pagination > li > a,
  .pagination > li > span {
    color: black;
    color: #000;
    font-weight: 500;
  }
  .pagination > li:first-of-type > a,
  .pagination > li:first-of-type > span,
  .pagination > li:last-child > a,
  .pagination > li:last-child > span {
    border-radius: unset;
  }
  .pagination > li.pagination-prev-btn > a {
    background-color: transparent;
  }
  .pagination > li.pagination-next-btn > a {
    background-color: transparent;
  }
  .pagination > li.pagination-prev-btn {
    margin-right: 4px;
  }
  .pagination > li.pagination-next-btn {
    margin-left: 4px;
  }
`;